import { render } from "./add_otp.vue?vue&type=template&id=097fcff7"
import script from "./add_otp.vue?vue&type=script&lang=js"
export * from "./add_otp.vue?vue&type=script&lang=js"

import "./add_otp.vue?vue&type=style&index=0&id=097fcff7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__